import * as z from 'zod';

import { currencyInput } from '@/_schemas/generic';

import { productAndServicesQueryLinkerSchema } from '../products-and-services/product-services-query-linker-schema';

export const productAndServicesTemplateItemQuerySchema = z.object({
  id: z.number(),
  product: productAndServicesQueryLinkerSchema
    .pick({
      id: true,
      name: true,
      sku: true,
      list_price: true,
      wholesale_price: true,
      // client_opt: true,
      // description: true,
      // price_frequency: true,
    })
    .nullable(),
  product_id: z.number(),
  product_template_id: z.number(),
  default_quantity: currencyInput.querySchema(),
  default_price: currencyInput.querySchema(),
  sort_order: z.number(),
});

export type ProductAndServicesTemplateItemQuerySchema = z.infer<typeof productAndServicesTemplateItemQuerySchema>;
